import styled from 'styled-components';
import { colors, breakpoints } from '../../../../../assets/styles/GlobalStyles';

export const InfoBox = styled.div`
  background: #f8fafc;
  border-radius: 12px;
  padding: 1.5rem;
  margin-bottom: 1.5rem;

  @media (max-width: 480px) {
    padding: 0.75rem;
  }
`;

export const InfoRow = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0.75rem 0;
  border-bottom: 1px solid #e2e8f0;
  
  &:last-child {
    border-bottom: none;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 0.5rem;
  }
`;

export const InfoLabel = styled.span`
  font-weight: 500;
  color: #475569;
`;

export const InfoValue = styled.span`
  color: #1e293b;
  font-weight: 500;
`;

export const RequiredBadge = styled.span`
  background: #dc2626;
  color: white;
  font-size: 0.65rem;
  padding: 0.2rem 0.5rem;
  border-radius: 4px;
  margin-left: 0.5rem;
  font-weight: 500;
`;

export const OptionalBadge = styled.span`
  background: #6b7280;
  color: white;
  font-size: 0.65rem;
  padding: 0.2rem 0.5rem;
  border-radius: 4px;
  margin-left: 0.5rem;
  font-weight: 500;
`;

export const ConditionalBadge = styled.span`
  background: #eab308;
  color: white;
  font-size: 0.65rem;
  padding: 0.2rem 0.5rem;
  border-radius: 4px;
  margin-left: 0.5rem;
  font-weight: 500;
`;

export const AutoGeradoBadge = styled.span`
  background: #16a34a;
  color: white;
  font-size: 0.65rem;
  padding: 0.2rem 0.5rem;
  border-radius: 4px;
  margin-left: 0.5rem;
  font-weight: 500;
`;

export const DocumentSection = styled.div`
  margin-bottom: 2rem;
  border: 1px solid ${colors.borderLight};
  border-radius: 12px;
  overflow: hidden;
`;

export const DocumentSectionHeader = styled.div`
  background: #f8fafc;
  padding: 1rem 1.5rem;
  font-weight: 600;
  color: ${colors.darkBlue};
  border-bottom: 1px solid ${colors.borderLight};
  font-size: 1rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    padding: 0.85rem 1rem;
    font-size: 0.9rem;
  }
`;

export const DocumentList = styled.div`
  padding: 1.5rem;

  @media (max-width: 480px) {
    padding: 0.75rem;
  }
`;

export const DocumentRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  border-bottom: 1px solid ${colors.borderLight};
  border-left: 3px solid ${props => props.$destaque ? '#dc2626' : 'transparent'};
  background: ${props => props.$destaque ? '#fef2f2' : 'transparent'};
  gap: 1rem;
  flex-wrap: wrap;
  scroll-margin-top: 6rem;
  transition: background 0.2s ease, border-color 0.2s ease;

  &:last-child {
    border-bottom: none;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

// Ocupa a linha inteira abaixo do nome/botão do documento.
export const DocumentErro = styled.small`
  flex-basis: 100%;
  color: #dc2626;
  font-size: 0.8rem;
  overflow-wrap: anywhere;

  @media (max-width: 768px) {
    flex-basis: auto;
  }
`;

export const DocumentInfo = styled.div`
  flex: 1;
  
  strong {
    display: block;
    margin-bottom: 0.25rem;
    font-size: 0.9rem;
  }
  
  small {
    font-size: 0.75rem;
    color: ${colors.textMuted};
    display: block;
  }
`;

export const DocumentActions = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;

  @media (max-width: 768px) {
    width: 100%;
    justify-content: space-between;
  }
`;

export const SelectFileButton = styled.button`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  color: ${colors.lightBlue};
  cursor: pointer;
  font-size: 0.8rem;
  font-weight: 500;
  padding: 0.5rem 1rem;
  border-radius: 8px;
  transition: all 0.2s;
  white-space: nowrap;
  
  &:hover {
    background: #f1f5f9;
    border-color: ${colors.lightBlue};
  }
  
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  @media (max-width: ${breakpoints.mobile}) {
    min-height: 40px;
  }
`;

export const DownloadButton = styled(SelectFileButton)``;

export const FileInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: #f1f5f9;
  padding: 0.4rem 0.8rem;
  border-radius: 8px;
  font-size: 0.8rem;
  max-width: 300px;

  span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  @media (max-width: 768px) {
    max-width: 100%;
    flex: 1;
  }
`;

export const RemoveButton = styled.button`
  background: none;
  border: none;
  color: #ef4444;
  cursor: pointer;
  padding: 0.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  min-width: 36px;
  min-height: 36px;
  border-radius: 4px;
  
  &:hover {
    background: #fee2e2;
  }

  @media (max-width: ${breakpoints.mobile}) {
    min-width: 40px;
    min-height: 40px;
  }
`;

// Usado pela tela de Pendências (PendenciaDocumentoItem).
export const ErrorMessage = styled.div`
  background: #fee2e2;
  color: #dc2626;
  padding: 0.75rem;
  border-radius: 8px;
  margin-bottom: 1rem;
  font-size: 0.875rem;
  overflow-wrap: anywhere;
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 1rem;
  margin-top: 2rem;
  justify-content: flex-end;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const ProgressBar = styled.div`
  background: #e2e8f0;
  border-radius: 10px;
  height: 8px;
  margin-bottom: 1rem;
  overflow: hidden;
`;

export const ProgressFill = styled.div.attrs(props => ({
  style: {
    width: `${props.$percent}%`
  }
}))`
  background: ${colors.lightBlue};
  height: 100%;
  transition: width 0.3s ease;
  border-radius: 10px;
`;

export const UploadStats = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 1rem;
  font-size: 0.8rem;
  color: ${colors.textMuted};
`;

export const InfoMessage = styled.div`
  background: #e0f2fe;
  border-left: 4px solid ${colors.lightBlue};
  padding: 1rem;
  border-radius: 8px;
  margin-bottom: 1rem;
  font-size: 0.875rem;
  color: #1e40af;
  
  strong {
    display: block;
    margin-bottom: 0.25rem;
  }
`;